import { InputAdornment, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Search } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "8px 5px",
    width: "100%",
    zIndex: 2,
    "& .MuiInputBase-root": {
      height: 20,
      fontSize: 14,
      padding: 12,
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& svg": {
        padding: 2,
      },
    },
  },
}));

const SearchFilter = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { placeholder, onChange } = props;
  let currentPath: string = props.location.pathname.replace("/", "");
  switch (true) {
    case /clients\//.test(currentPath):
    case /workouts\/share/.test(currentPath):
      currentPath = "clients";
      break;
    case /exercises\//.test(currentPath):
    case /workouts\//.test(currentPath):
      currentPath = "exercises";
      break;
    default:
      break;
  }

  const placeholderText = t(`Search for ${placeholder ? placeholder : currentPath}`);

  return (
    <Paper className={`${classes.paper} ${props.className}`}>
      <TextField
        fullWidth
        id="search-filter"
        type="search"
        variant="outlined"
        placeholder={placeholderText}
        onChange={onChange}
        inputProps={{
          "aria-label": placeholderText,
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" style={{ color: "#9B9B9B" }}>
              <Search />
            </InputAdornment>
          ),
        }}
      />
    </Paper>
  );
};

export default withRouter(SearchFilter);
